<template>
  <div class="interest-public">
    <mt-header class="title1 new-mint-header" title="注册" fixed />
    <div class="container">
      <div class="form">
        <!-- 选择产品 -->
        <div class="item" v-if="product.rowVisible">
          <div class="label">
            <span>产品名称</span>
          </div>
          <div class="value">
            <div class="product" @click="onProductClick">
              <span :class="product.style">{{ form.product }}</span>
              <mt-actionsheet :actions="product.list" v-model="product.visible"> </mt-actionsheet>
            </div>
          </div>
        </div>
        <!-- 邀请码 -->
        <div class="item">
          <div class="label">
            <span>邀请码</span>
          </div>
          <div class="value">
            <input type="tel" class="text" v-model="form.invite" placeholder="请输入邀请码" :disabled="validateCode.inputDisabled" @input="onInviteInput" />
          </div>
        </div>
        <!-- 手机号 -->
        <div class="item">
          <div class="label">
            <span>手机号</span>
          </div>
          <div class="value">
            <input type="tel" class="text" v-model="form.mobile" maxlength="13" placeholder="请输入手机号码" @input="onMobileInput" />
            <div class="clear" v-show="form.mobile" @click="onClearMobileClick">
              <img :src="require('@/assets/clear.png')" alt />
            </div>
          </div>
        </div>
        <!-- 验证码 -->
        <div class="item">
          <div class="label">
            <span>验证码</span>
          </div>
          <div class="value">
            <input type="tel" class="text w-50" v-model="form.validate" maxlength="6" placeholder="请输入验证码" @input="onValidateInput" />
            <button class="validate" :disabled="validateCode.disabled" @click="onValidateCodeClick">
              {{ validateCode.label }}
            </button>
          </div>
        </div>
        <!-- 登录密码 -->
        <div class="item">
          <div class="label">
            <span>登录密码</span>
          </div>
          <div class="value">
            <input :type="pwd1.type" class="text" v-model="form.pwd1" maxlength="30" placeholder="登录密码(6位以上数字或字母)" @input="onPwd1Input" />
            <div class="eye1" @click="onEye1Click">
              <svg-icon :icon-class="pwd1.svgPath" class-name="cur-icon"></svg-icon>
            </div>
          </div>
        </div>
        <!-- 确认登录密码 -->
        <div class="item">
          <div class="label no-border">
            <span>确认密码</span>
          </div>
          <div class="value no-border">
            <input :type="pwd2.type" class="text" v-model="form.pwd2" maxlength="30" placeholder="确认登录密码" @input="onPwd2Input" />
            <div class="eye2" @click="onEye2Click">
              <svg-icon :icon-class="pwd2.svgPath" class-name="cur-icon"></svg-icon>
            </div>
          </div>
        </div>
      </div>
      <!-- 注册协议 -->
      <div class="check-row">
        <div class="row" @click="onCheckClick">
          <svg-icon :icon-class="check.svgPath" class-name="cur-icon"></svg-icon>
        </div>
        <span class="text">
          我已阅读并同意
          <span class="link" @click="onToAgreementClick">《注册协议》</span>
        </span>
      </div>
      <!-- 提交按钮 -->
      <div class="btn-row">
        <mt-button type="primary" size="large" :disabled="btn.disabled" @click="onRegisterClick">
          注 册
        </mt-button>
      </div>
    </div>
    <mt-popup class="register-agreement" v-model="agreement.visible">
      <div class="container">
        <div class="title">恒信通注册协议</div>
        <div class="content" v-html="agreement.text"></div>
        <div class="btn" @click="onAgreementClose">关闭</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
/* global
    appid,
    request,
    request2,
    PUBLIC_PRODUCT,
    PUBLIC_MOBILE_REGEXP,
    PUBLIC_AGREEMENT_TEXT,
    PUBLIC_WELCOME_SOURCE_TYPE
  */

import { Indicator, MessageBox } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { GetTokenBySh, GetConfigBySh, GetMobileVerificationCodeByParam, RegUserByParam } from '@/api/interface';
import { SendRequest } from '@/api/official';
import { SucceedHandle, SucceedHandle2, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'InterestPublicRegister',
  data() {
    return {
      timing: null,
      ajax: {
        token: '',
        regUrl: '',
        vdCodeUrl: '',
        getOpenidUrl: '',
        openid: '',
        inviteSourceType: PUBLIC_WELCOME_SOURCE_TYPE || 0,
        configGetIsNeedInviteCode: '',
      },
      form: {
        mobile: '',
        validate: '',
        pwd1: '',
        pwd2: '',
        invite: '',
        product: '请选择产品',
        city: '',
      },
      validateCode: {
        disabled: false,
        inputDisabled: false,
        label: '获取验证码',
      },
      pwd1: {
        type: 'password',
        svgPath: 'hide_money',
      },
      pwd2: {
        type: 'password',
        svgPath: 'hide_money',
      },
      product: {
        list: [
          {
            name: '易付通',
            method: () => {
              this.product.style = 'word';
              this.form.product = '易付通';
              this.ajax.regUrl = `${request.yft}/api/Login/RegUser`;
              this.ajax.vdCodeUrl = `${request.yft}/api/Login/GetMobileVerificationCode`;
              this.ajax.getOpenidUrl = `${request2.yft}api/OfficialAccount/GetWXOpenId`;
              this.initAll();
            },
          },
          {
            name: '诚享易付',
            method: () => {
              this.product.style = 'word';
              this.form.product = '诚享易付';
              this.ajax.regUrl = `${request.cxyf}/api/Login/RegUser`;
              this.ajax.vdCodeUrl = `${request.cxyf}/api/Login/GetMobileVerificationCode`;
              this.ajax.getOpenidUrl = `${request2.cxyf}api/OfficialAccount/GetWXOpenId`;
              this.initAll();
            },
          },
          {
            name: '诚享PLUS',
            method: () => {
              this.product.style = 'word';
              this.form.product = '诚享PLUS';
              this.ajax.regUrl = `${request.cxplus}/api/Login/RegUser`;
              this.ajax.vdCodeUrl = `${request.cxplus}/api/Login/GetMobileVerificationCode`;
              this.ajax.getOpenidUrl = `${request2.cxplus}api/OfficialAccount/GetWXOpenId`;
              this.initAll();
            },
          },
          {
            name: '恒付PLUS',
            method: () => {
              this.product.style = 'word';
              this.form.product = '恒付PLUS';
              this.ajax.regUrl = `${request.hfplus}/api/Login/RegUser`;
              this.ajax.vdCodeUrl = `${request.hfplus}/api/Login/GetMobileVerificationCode`;
              this.ajax.getOpenidUrl = `${request2.hfplus}api/OfficialAccount/GetWXOpenId`;
              this.initAll();
            },
          },
        ],
        visible: false,
        rowVisible: false,
        style: 'placeholder',
        param: PUBLIC_PRODUCT.toLowerCase().trim() || '',
      },
      check: {
        state: true,
        svgPath: 'selected_coupons',
      },
      btn: {
        disabled: false,
      },
      agreement: {
        visible: false,
        text: PUBLIC_AGREEMENT_TEXT,
      },
      isTest: false,
      appid: appid.wx_official_id,
      registerSuccess: false,
    };
  },
  created() {
    if (!this.isTest) {
      const code = this.getUrlKey('code');
      if (code) {
        this.ajax.code = code;
      } else {
        this.getCodeApi(Math.floor(Math.random() * 900000 + 100000));
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.registerSuccess = false;
      this.initProduct();
      this.initAgreement();
      this.apiGetTokenBySh();
    });
  },
  methods: {
    // 获取url参数
    getUrlKey(name) {
      // 获取url 参数
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
    },
    // 微信交互，获取code
    getCodeApi(state = '') {
      const appid = this.appid;
      const urlNow = encodeURIComponent(window.location.href);
      const scope = 'snsapi_base'; // snsapi_userinfo   //静默授权 用户无感知
      const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
      window.location.replace(url);
    },
    // 接口获取openid
    getOpenid(jsCode = '', ok = null) {
      SendRequest(this.ajax.getOpenidUrl, { jsCode })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.data.openid) {
                this.ajax.openid = res.data.openid;
                ok && ok();
              } else {
                CusToast('openid为空');
              }
            },
            (code, msg) => {
              Indicator.close();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 初始化所有数据
    initAll() {
      this.form.mobile = '';
      this.form.validate = '';
      this.form.pwd1 = '';
      this.form.pwd2 = '';
      this.form.invite = '';
      this.form.city = '';
      this.validateCode.disabled = false;
      this.validateCode.inputDisabled = false;
      this.validateCode.label = '获取验证码';
      this.pwd1.type = 'password';
      this.pwd1.svgPath = 'hide_money';
      this.pwd2.type = 'password';
      this.pwd2.svgPath = 'hide_money';
      this.check.state = true;
      this.check.svgPath = 'selected_coupons';
      this.btn.disabled = false;
      this.timing = null;
      this.registerSuccess = false;
    },
    // 根据url产品标识初始化选择产品行
    initProduct() {
      if (this.product.param) {
        this.product.rowVisible = false;
        switch (this.product.param) {
          case 'yft':
            this.ajax.regUrl = `${request.yft}/api/Login/RegUser`;
            this.ajax.vdCodeUrl = `${request.yft}/api/Login/GetMobileVerificationCode`;
            this.ajax.getOpenidUrl = `${request2.yft}api/OfficialAccount/GetWXOpenId`;
            break;
          case 'cxyf':
            this.ajax.regUrl = `${request.cxyf}/api/Login/RegUser`;
            this.ajax.vdCodeUrl = `${request.cxyf}/api/Login/GetMobileVerificationCode`;
            this.ajax.getOpenidUrl = `${request2.cxyf}api/OfficialAccount/GetWXOpenId`;
            break;
          case 'cxplus':
            this.ajax.regUrl = `${request.cxplus}/api/Login/RegUser`;
            this.ajax.vdCodeUrl = `${request.cxplus}/api/Login/GetMobileVerificationCode`;
            this.ajax.getOpenidUrl = `${request2.cxplus}api/OfficialAccount/GetWXOpenId`;
            break;
          case 'hfplus':
            this.ajax.regUrl = `${request.hfplus}/api/Login/RegUser`;
            this.ajax.vdCodeUrl = `${request.hfplus}/api/Login/GetMobileVerificationCode`;
            this.ajax.getOpenidUrl = `${request2.hfplus}api/OfficialAccount/GetWXOpenId`;
            break;
          default:
            this.ajax.regUrl = `${request.yft}/api/Login/RegUser`;
            this.ajax.vdCodeUrl = `${request.yft}/api/Login/GetMobileVerificationCode`;
            this.ajax.getOpenidUrl = `${request2.yft}api/OfficialAccount/GetWXOpenId`;
            break;
        }
      } else {
        this.product.rowVisible = true;
      }
    },
    // 初始化协议文本
    initAgreement() {
      this.agreement.text = this.agreement.text.replace(/tmpCustomAppName/g, '所选产品');
    },
    // 调用接口，获得token （商户使用）
    apiGetTokenBySh() {
      GetTokenBySh()
        .then(res => {
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.ajax.token = res.data.token;
            // 2020.11.6 添加获取config配置信息 （代理商使用）
            GetConfigBySh()
              .then(res => {
                const msg = SucceedHandle(res.code, res.msg, () => {
                  this.ajax.configGetIsNeedInviteCode = res.data.needWelcomeCode;
                });
                msg && CusToast(msg);
              })
              .catch(err => {
                const msg = NotSucceedHandle(err.message);
                msg && CusToast(msg);
              });
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，获取注册码（商户使用）
    apiGetMobileVerificationCode(welcomeCode = '') {
      GetMobileVerificationCodeByParam(this.ajax.token, this.ajax.vdCodeUrl, {
        cityCode: this.form.city,
        MobileNumber: this.form.mobile.replace(/\s/gi, ''),
        welcomeCode: welcomeCode.replace(/\s/gi, ''),
        sourceType: this.ajax.inviteSourceType,
      })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              // 2020.11.6添加，输入邀请码后点击获取验证码，不允许再次输入邀请码
              if (this.form.invite) {
                this.validateCode.inputDisabled = true;
              }
              let time = 60;
              this.validateCode.disabled = true;
              const sendSms = function () {
                if (time > 0) {
                  this.validateCode.label = time + '秒后重新获取';
                  time -= 1;
                } else {
                  this.endTiming();
                }
                return sendSms;
              }.bind(this);
              this.timing = setInterval(sendSms(), 1000);
            },
            (code, msg) => {
              // 2020.11.6添加，未获得邀请资质时，提示是否继续
              // 如果继续则清空邀请码并进入倒计时
              if (code === 9073) {
                MessageBox({
                  title: '',
                  message: '尚未获得邀请资质',
                  showCancelButton: true,
                  confirmButtonText: '继续注册',
                  confirmButtonHighlight: true,
                  closeOnClickModal: false,
                }).then(action => {
                  if (action === 'confirm') {
                    this.form.invite = '';
                    this.apiGetMobileVerificationCode();
                  }
                });
              } else {
                msg && CusToast(msg);
              }
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，注册（商户使用）
    apiRegUser() {
      Indicator.open();
      RegUserByParam(this.ajax.token, this.ajax.regUrl, {
        MobileNumber: this.form.mobile.replace(/\s/gi, ''),
        MobileNumberCode: this.form.validate,
        LoginPassword: this.form.pwd1,
        SharingSources: 'H5',
        welcomeCode: this.form.invite,
        cityCode: this.form.city,
        openid: this.ajax.openid,
      })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.registerSuccess = true;
            CusToast('注册成功');
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 验证产品
    validateProductVal() {
      if (!this.product.param && this.form.product === '请选择产品') {
        CusToast('请选择要注册的产品');
        return 'err';
      }
      return 'ok';
    },
    // 验证邀请码
    validateInviteCodeVal() {
      const val = this.form.invite.replace(/\s/gi, '');
      if (val.length > 11) {
        CusToast('邀请码位数过长');
        return 'err';
      }
      if (val.length > 0 && val.length < 11) {
        CusToast('邀请码位数过短');
        return 'err';
      }
      const regExp = PUBLIC_MOBILE_REGEXP;
      if (val && !regExp.test(val)) {
        CusToast('邀请码格式不正确');
        return 'err';
      }
      if (val === '') {
        CusToast('邀请码不能为空');
        return 'err';
      }
      return 'ok';
    },
    // 验证手机号码
    validateMobileNumVal() {
      const val = this.form.mobile.replace(/\s/gi, '');
      if (val === '') {
        CusToast('手机号码不能为空');
        return 'err';
      }
      const regExp = PUBLIC_MOBILE_REGEXP;
      if (!regExp.test(val)) {
        CusToast('手机号码格式不正确');
        return 'err';
      }
      return 'ok';
    },
    // 验证短信验证码
    validateCodeVal() {
      if (this.form.validate === '') {
        CusToast('短信验证码不能为空');
        return 'err';
      }
      return 'ok';
    },
    // 验证密码框1
    validatePwd1Val() {
      if (this.form.pwd1 === '') {
        CusToast('登录密码不能为空');
        return 'err';
      }
      const arr = this.form.pwd1.split('');
      const isOk = /^[A-Za-z0-9]+$/.test(this.form.pwd1);
      if (arr.length < 6 || !isOk) {
        CusToast('登录密码为6位以上数字或字母');
        return 'err';
      }
      // 验证都是数字的情况下不能是相同\连续的数字
      if (/^[0-9]*[1-9][0-9]*$/.test(this.form.pwd1)) {
        const differ = [];

        const pwdArr = this.form.pwd1.split('');

        let count0 = 0;

        let count1 = 0;

        let count2 = 0;
        for (let i = 0; i < pwdArr.length - 1; ++i) {
          differ.push(pwdArr[i + 1] - pwdArr[i]);
        }
        for (let i = 0; i < differ.length; i++) {
          differ[i] === 0 && count0++;
          differ[i] === 1 && count1++;
          differ[i] === -1 && count2++;
        }
        if (count0 === differ.length) {
          CusToast('密码不能是重复的数字');
          return 'err';
        }
        if (count1 === differ.length) {
          CusToast('密码不能是连续的数字');
          return 'err';
        }
        if (count2 === differ.length) {
          CusToast('密码不能是连续的数字');
          return 'err';
        }
      }
      return 'ok';
    },
    // 验证再次输入密码框
    validatePwd2Val() {
      if (this.form.pwd1 !== this.form.pwd2) {
        CusToast('两次密码输入的不一致');
        return 'err';
      }
      return 'ok';
    },
    // 结束倒计时
    endTiming() {
      clearInterval(this.timing);
      this.validateCode.disabled = false;
      this.validateCode.label = '获取验证码';
    },
    // 手机号码input事件
    onMobileInput() {
      // 获取正在输入的最后一位字符
      const last = this.form.mobile.charAt(this.form.mobile.length - 1);
      // 自动将非法字符替换成空
      this.form.mobile = '1234567890 '.indexOf(last) < 0 ? this.form.mobile.replace(last, '') : this.form.mobile;
      // 第3位自动加空格，格式为：XXX XXXX
      if (this.form.mobile.length === 4 && last !== ' ') {
        const arr = this.form.mobile.split('');
        arr.splice(3, 0, ' ');
        this.form.mobile = arr.join('');
      }
      // 第8位自动加空格，格式为：XXX XXXX XXXX
      if (this.form.mobile.length === 9 && last !== ' ') {
        const arr = this.form.mobile.split('');
        arr.splice(8, 0, ' ');
        this.form.mobile = arr.join('');
      }
    },
    // 邀请码input事件
    onValidateInput() {
      // 获取正在输入的最后一位字符
      const last = this.form.validate.charAt(this.form.validate.length - 1);
      // 自动将非法字符替换成空
      this.form.validate = '1234567890'.indexOf(last) < 0 ? this.form.validate.replace(last, '') : this.form.validate;
    },
    // 密码1input事件
    onPwd1Input() {
      // 获取最后一位字符
      const last = this.form.pwd1.charAt(this.form.pwd1.length - 1);
      // 自动将非法字符替换成空
      this.form.pwd1 = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(last) < 0 ? this.form.pwd1.replace(last, '') : this.form.pwd1;
      // 自动将汉字符替换成空
      this.form.pwd1 = this.form.pwd1.replace(/[\u4E00-\u9FA5]/g, '');
    },
    // 密码2input事件
    onPwd2Input() {
      // 获取最后一位字符
      const last = this.form.pwd2.charAt(this.form.pwd2.length - 1);
      // 自动将非法字符替换成空
      this.form.pwd2 = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(last) < 0 ? this.form.pwd2.replace(last, '') : this.form.pwd2;
      // 自动将汉字符替换成空
      this.form.pwd2 = this.form.pwd2.replace(/[\u4E00-\u9FA5]/g, '');
    },
    // 邀请码input事件
    onInviteInput() {
      // 获取最后一位字符
      const last = this.form.invite.charAt(this.form.invite.length - 1);
      // 自动将非法字符替换成空
      this.form.invite = '1234567890 '.indexOf(last) < 0 ? this.form.invite.replace(last, '') : this.form.invite;
      // 第3位自动加空格，格式为：XXX XXXX
      if (this.form.invite.length === 4 && last !== ' ') {
        const arr = this.form.invite.split('');
        arr.splice(3, 0, ' ');
        this.form.invite = arr.join('');
      }
      // 第8位自动加空格，格式为：XXX XXXX XXXX
      if (this.form.invite.length === 9 && last !== ' ') {
        const arr = this.form.invite.split('');
        arr.splice(8, 0, ' ');
        this.form.invite = arr.join('');
      }
    },
    // 清空手机号图片点击事件
    onClearMobileClick() {
      this.form.mobile = '';
    },
    // 验证码点击事件
    onValidateCodeClick() {
      // 验证
      if (this.validateProductVal() === 'err') return;
      if (this.validateInviteCodeVal() === 'err') return;
      if (this.validateMobileNumVal() === 'err') return;
      // 调用接口
      this.apiGetMobileVerificationCode(this.form.invite);
    },
    // 眼睛1点击事件
    onEye1Click() {
      if (this.pwd1.svgPath === 'hide_money') {
        this.pwd1.svgPath = 'show_money';
        this.pwd1.type = 'text';
      } else {
        this.pwd1.svgPath = 'hide_money';
        this.pwd1.type = 'password';
      }
    },
    // 眼睛2点击事件
    onEye2Click() {
      if (this.pwd2.svgPath === 'hide_money') {
        this.pwd2.svgPath = 'show_money';
        this.pwd2.type = 'text';
      } else {
        this.pwd2.svgPath = 'hide_money';
        this.pwd2.type = 'password';
      }
    },
    // 产品点击事件
    onProductClick() {
      this.product.visible = true;
    },
    // 注册协议check点击事件
    onCheckClick() {
      this.check.state = !this.check.state;
      this.btn.disabled = !this.check.state;
      this.check.svgPath = this.check.state ? 'selected_coupons' : 'unselected_coupons';
    },
    // 显示注册协议的点击事件
    onToAgreementClick() {
      this.agreement.visible = true;
    },
    // 注册协议弹窗关闭
    onAgreementClose() {
      this.agreement.visible = false;
    },
    // 注册按钮事件
    onRegisterClick() {
      if (this.registerSuccess) {
        CusToast('您已成功注册，可离开当前页面');
        return;
      }
      // 点击按钮的控件验证
      if (this.validateProductVal() === 'err') return;
      if (this.validateInviteCodeVal() === 'err') return;
      if (this.validateMobileNumVal() === 'err') return;
      if (this.validateCodeVal() === 'err') return;
      if (this.validatePwd1Val() === 'err') return;
      if (this.validatePwd2Val() === 'err') return;
      // 根据标识调用不同接口
      // 先获取openid再注册
      this.getOpenid(this.ajax.code, this.apiRegUser);
    },
  },
};
</script>
